export default __webpack_public_path__ + "static/media/DJI_0895.MP4.00_00_44_02.Still005.c7f49973.jpg";